import{e as t,g as o,m as e}from"./chunk-HBP5N4FR.js";var a={};o(a,{css:()=>p,default:()=>_});var p,_,s=t(()=>{e();p=`.dapp-core-component__styles__scResultWrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
@media (min-width: 576px) {
  .dapp-core-component__styles__scResultWrapper {
    flex-direction: row;
  }
}
.dapp-core-component__styles__scResultWrapper .dapp-core-component__styles__label {
  color: #6c757d;
}
@media (min-width: 576px) {
  .dapp-core-component__styles__scResultWrapper .dapp-core-component__styles__label {
    text-align: right;
  }
}
.dapp-core-component__styles__scResultWrapper .dapp-core-component__styles__data {
  display: flex;
  align-items: center;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(p));_={scResultWrapper:"dapp-core-component__styles__scResultWrapper",label:"dapp-core-component__styles__label",data:"dapp-core-component__styles__data"}});export{p as a,_ as b,a as c,s as d};
//# sourceMappingURL=chunk-3XLNWKLP.js.map
